// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","ly_manage":"d_CADC","AniFadeIn":"Enl5HM","AniFadeOut":"MLA3Z7","AniRotate":"TWQiv5","AniPlaceholderFadeOut":"BsFJt4"};